function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ce0e2d;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        display: none;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "color"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 496.62,
  height: 495
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "_2023",
  "data-name": 2023
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M106.26,412.63c6.3-4.31,13.45-9.19,13.45-18.04,0-8.28-6.26-14.06-15.22-14.06-10.42,0-15.04,8.91-15.08,9l-.26.51,4.6,3.1.35-.61c.04-.06,3.59-6.2,10.12-6.2,5.47,0,9.29,3.51,9.29,8.54,0,5.7-5.23,9.32-10.77,13.14-6.44,4.45-13.74,9.49-13.74,18.79,0,1.13.09,2.17.28,3.19l.1.53h31.08v-5.52h-24.96c.41-5.27,5.45-8.71,10.76-12.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M190.28,380.3c-11.25,0-17.19,8.77-17.19,25.36s5.95,25.43,17.19,25.43,17.13-8.56,17.13-25.43-5.92-25.36-17.13-25.36ZM201.2,405.67c0,13.44-3.47,19.71-10.92,19.71s-10.99-6.26-10.99-19.71,3.49-19.64,10.99-19.64,10.92,6.24,10.92,19.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M277.9,412.03c6.3-4.31,13.45-9.19,13.45-18.04,0-8.28-6.26-14.06-15.22-14.06-10.42,0-15.04,8.91-15.08,9l-.26.51,4.6,3.1.35-.61c.03-.06,3.57-6.2,10.12-6.2,5.47,0,9.29,3.51,9.29,8.54,0,5.7-5.23,9.32-10.77,13.14-6.44,4.45-13.74,9.49-13.74,18.79,0,1.12.09,2.17.28,3.18l.1.53h31.08v-5.52h-24.96c.41-5.27,5.45-8.71,10.76-12.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M371.87,429.86v-13.53h-23.08v-4.43l22.17-31.72h7.26v30.88h6.96v5.27h-6.96v13.53h-6.34ZM371.87,411.06v-16.59c0-2.6.08-5.2.23-7.8h-.23c-1.53,2.9-2.75,5.04-4.13,7.34l-12.15,16.89v.15h16.28Z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "txt"
}, /*#__PURE__*/React.createElement("g", {
  id: "orkla_old",
  className: "cls-3"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M124.04,143.1c22.33,0,39.81,17.39,39.81,39.58s-17.49,39.27-39.81,39.27-39.82-17.25-39.82-39.27,17.49-39.58,39.82-39.58M124.04,209.34c14.7,0,25.79-11.46,25.79-26.67s-11.09-26.67-25.79-26.67-25.8,11.47-25.8,26.67,11.09,26.67,25.8,26.67"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M284.96,220.58h-14.03v-77.05c0-3.09,3.8-6.49,10.37-6.49h3.66v83.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M341.54,168.25v-.74c0-3.95,5.07-6.55,10.09-6.55h3.46v59.63h-13.55v-7.1s-7.8,8.68-20.96,8.68c-20.53,0-30.24-16.84-30.24-31.8s9.72-30.99,30.24-30.99c13.16,0,20.96,8.87,20.96,8.87ZM322.28,210.53c12.11,0,18.79-8.68,18.79-20.16s-7.4-19.37-18.79-19.37-18.8,7.89-18.8,19.35,7.31,20.17,18.8,20.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M204.83,160.18v11.33c-1.54-.07-3.34-.13-5.02-.13-10.41,0-15.77,1.56-15.77,1.56v47.61h-14.03v-49.35c0-4.9,9.43-11.11,30.61-11.11,0,0,2.85.04,4.21.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M209.94,220.58v-77.05c0-3.09,3.8-6.49,10.4-6.49h3.65v44.41l21.55-20.45,18.02-.02-27.36,25.53,32.21,34.07h-17.73l-23.83-25.2-2.86,2.71v22.49h-14.05Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M93.16,116.43h-7.78l-11.74-36.56c-.27-.83-1.42-.83-1.69,0l-11.75,36.56H25.24c-.86,0-1.22,1.1-.52,1.61l31.7,23.03s.06,0,.04-.03l-10.47-16.97h20.49l6.32-19.95,6.4,20.18c3.54-2.77,10.51-6.58,13.97-7.82.02,0,.02-.05,0-.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M107.29,116.43c-14.61,0-50.95,20.77-50.98,66.52,0,.03.03.06.06.06.03,0,.06-.02.06-.06,3.33-22.72,15.15-36.4,26.71-46.24,13.95-11.87,39.12-17.81,41.56-18.56.38-.11.6-.5.59-.83,0-.49-.38-.88-.88-.88h-17.13Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "orkla_new"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1674",
  "data-name": "Path 1674",
  className: "cls-2",
  d: "M123.4,143.82c21.48-.3,39.14,16.88,39.44,38.36,0,0,0,0,0,0,0,.28,0,.56,0,.85,0,21.82-17.32,38.91-39.44,38.91s-39.45-17.09-39.45-38.91,17.33-39.21,39.45-39.21M123.4,209.46c14.57,0,25.55-11.36,25.55-26.42s-10.98-26.43-25.55-26.43-25.56,11.36-25.56,26.42,10.99,26.42,25.56,26.42"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_1675",
  "data-name": "Path 1675",
  className: "cls-2",
  d: "M341.2,162.73v6.01h0c-4.91-5.7-12.09-8.92-19.61-8.79-20.33,0-29.96,15.75-29.96,30.7s9.62,31.5,29.96,31.5c7.48.16,14.65-2.99,19.61-8.59v7.03h13.89v-60.27l-13.89,2.4ZM323.26,210.63c-11.37,0-17.75-8.62-17.75-19.98s6.18-19.18,17.75-19.18,17.9,7.81,17.9,19.18-5.9,19.97-17.9,19.97Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1676",
  "data-name": "Path 1676",
  className: "cls-2",
  d: "M184.58,171.48v-11.16l-13.9,2.4v57.87h13.9v-.04h0v-34.44c0-10.26,9.58-13.17,19.07-11.99v-13.97c-7.5-1.27-15.37,2.94-19.07,11.32Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1677",
  "data-name": "Path 1677",
  className: "cls-2",
  d: "M241.51,186.94l22.08-25.4h-17.33l-21.7,25.73v-49.44l-13.9,2.41v80.36h13.9v-15.08l8.25-8.91,16.42,23.99h16.88l-24.58-33.66ZM241.51,186.94h0s0,0,0,0h0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1678",
  "data-name": "Path 1678",
  className: "cls-2",
  d: "M284.37,137.83l-13.89,2.41v80.36h13.9v-82.76Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  className: "cls-2",
  d: "M71.71,81.1l-11.7,36.37H25.23c-.49,0-.89.4-.88.89,0,.28.14.55.37.72l31.54,22.91s.03,0,.04,0c0,0,0,0,0,0,0,0,0-.02,0-.03l-10.41-16.88h20.38l6.29-19.84,5.94,18.72c3.3-2.53,6.85-4.7,10.62-6.47h-4.04l-11.68-36.37c-.15-.46-.64-.72-1.1-.57-.27.09-.49.3-.58.57"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_579",
  "data-name": "Group 579"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1692",
  "data-name": "Path 1692",
  className: "cls-2",
  d: "M106.87,117.47c-14.54,0-50.69,20.66-50.72,66.18,0,.03.02.05.05.06h0s.06-.02.06-.05c0,0,0,0,0,0h0c3.31-22.6,15.07-36.22,26.57-46,13.88-11.81,38.92-17.72,41.35-18.47.46-.16.7-.66.55-1.12,0,0,0,0,0,0-.12-.35-.46-.59-.83-.59h-17.04Z"
})))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M109.78,242.02c11,0,16.87,5.53,16.87,5.53l-2.5,3.51s-5.53-4.72-14.17-4.72c-11.47,0-19.23,8.84-19.23,20.11s8.03,20.31,18.83,20.31c9.24,0,14.91-6.95,14.91-6.95v-8.03h-8.1v-4.18h12.55v22.67h-4.32v-3.58c0-1.01.07-2.02.07-2.02h-.14s-5.47,6.41-15.45,6.41c-12.96,0-23.21-10.46-23.21-24.56s10.26-24.49,23.89-24.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M140.85,242.83h14.04c4.86,0,7.02.47,8.91,1.28,4.45,1.96,7.15,6.48,7.15,12.21,0,6.41-3.64,11.34-8.97,12.82v.14s.47.61,1.21,1.89l10.32,19.1h-5.33l-10.73-19.97h-11.94v19.97h-4.66v-47.44ZM156.77,266.11c5.74,0,9.38-3.71,9.38-9.65,0-3.91-1.55-6.82-4.32-8.3-1.42-.74-3.1-1.15-6.75-1.15h-9.58v19.1h11.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M205.06,242.02c13.43,0,24.16,10.59,24.16,24.22s-10.73,24.83-24.16,24.83-24.16-10.93-24.16-24.83,10.73-24.22,24.16-24.22ZM205.06,286.76c10.66,0,19.3-8.91,19.3-20.51s-8.64-19.91-19.3-19.91-19.3,8.57-19.3,19.91,8.57,20.51,19.3,20.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M264.77,249.65s-.74,4.05-1.55,7.08l-9.04,33.4h-5.6l-12.28-47.44h4.86l9.18,36.84c.61,2.43,1.08,5.06,1.08,5.06h.14c.07,0,.41-2.63,1.08-5.06l9.99-36.84h4.45l9.99,36.84c.68,2.43,1.01,5.06,1.08,5.06h.14s.47-2.63,1.08-5.06l9.51-36.84h4.86l-12.62,47.44h-5.6l-9.04-33.4c-.81-3.04-1.55-7.08-1.55-7.08h-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M314.7,247.02h-17.07v-4.18h38.73v4.18h-17v43.25h-4.66v-43.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M342.82,242.83h4.76v21.59h28.17v-21.59h4.76v47.44h-4.76v-21.66h-28.17v21.66h-4.76v-47.44Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M112.5,345.09h-17.95l-4.72,13.7h-6.88l17.14-47.64h7.02l17.14,47.64h-6.95l-4.79-13.7ZM103.52,317.69s-1.08,4.32-1.89,6.75l-5.33,15.12h14.44l-5.26-15.12c-.81-2.43-1.82-6.75-1.82-6.75h-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M164.37,311.14l9.31,34.95c.67,2.63,1.01,5.06,1.01,5.06h.14s.2-2.5.88-5.06l8.77-34.95h6.88l-12.48,47.64h-7.76l-8.23-30.91c-.81-3.04-1.42-6.75-1.42-6.75h-.14s-.61,3.71-1.42,6.75l-8.23,30.91h-7.76l-12.15-47.64h6.88l8.43,34.95c.61,2.56.88,5.06.88,5.06h.14s.34-2.43,1.01-5.06l9.31-34.95h5.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M228.93,345.09h-17.95l-4.72,13.7h-6.88l17.14-47.64h7.02l17.14,47.64h-6.95l-4.79-13.7ZM219.95,317.69s-1.08,4.32-1.89,6.75l-5.33,15.12h14.44l-5.26-15.12c-.81-2.43-1.82-6.75-1.82-6.75h-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M252.66,311.14h14.58c4.99,0,7.09.41,8.91,1.08,4.86,1.82,8.03,6.61,8.03,12.89s-3.37,11.2-8.57,12.89v.14s.54.61,1.42,2.16l10.12,18.49h-7.56l-10.05-18.96h-10.19v18.96h-6.68v-47.64ZM268.92,334.02c5.2,0,8.44-3.31,8.44-8.64,0-3.51-1.35-6.01-3.78-7.35-1.28-.68-2.83-1.08-6.55-1.08h-7.69v17.07h9.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M300.5,311.28h15.79c14.58,0,24.16,8.7,24.16,23.75s-9.58,23.89-24.16,23.89h-15.79v-47.64ZM315.82,353.11c10.73,0,17.75-6.34,17.75-18.08s-7.09-17.95-17.75-17.95h-8.64v36.03h8.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M354.97,348.26s5.06,5.13,12.15,5.13c4.45,0,8.23-2.5,8.23-7.02,0-10.32-23.08-8.1-23.08-22.74,0-7.42,6.41-13.29,15.39-13.29s13.5,4.79,13.5,4.79l-3.04,5.53s-4.39-4.12-10.46-4.12c-5.06,0-8.64,3.17-8.64,6.95,0,9.85,23.08,7.22,23.08,22.67,0,7.35-5.67,13.43-15.12,13.43-10.12,0-15.79-6.28-15.79-6.28l3.78-5.06Z"
})));

function SvgOga24LogoV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 496.62 495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOga24LogoV2);
export default __webpack_public_path__ + "static/media/oga24_logo_v2.4797f420.svg";
export { ForwardRef as ReactComponent };